const { displayMessage } = require('../helpers/messages')

export const ECentralAlertTypes = {
    FIRE: { code: 0, type: '1', label: displayMessage('FIRE'), color: '#EE3F54' },
    SUPERVISION: { code: 1, type: '2', label: displayMessage('SUPERVISION'), color: '#F5AC1E' },
    FAIL: { code: 2, type: '3', label: displayMessage('FAIL'), color: '#F5AC1E' },
    DISABLE: { code: 3, type: '4', label: displayMessage('DISABLE'), color: '#F5AC1E' },
    CENTRAL_FAIL: { code: '', type: '5', label: displayMessage('CENTRAL_FAIL'), color: '#F5AC1E' },
}
